<template>
  <div id="main-layout" class="vh-100">
    <Transition name="fade" mode="out-in">
      <component :is="layout"></component>
    </Transition>
  </div>

</template>

<script>
import LoginLayout from "./components/layouts/Login";
import PrincipalLayout from "./components/layouts/Principal";
import LoadingLayout from "./components/layouts/Loading";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: { LoginLayout, PrincipalLayout, LoadingLayout },
  data() {
    return {
      app_name: process.env.APP_NAME
    }
  },
  methods: {
    ...mapActions("auth", ["logout", "verify"])
  },
  computed: {
    ...mapGetters("auth", ["layout",]),
    ...mapState('auth', ["user", "authError", "authType", "loggingOut"]),

  },
  mounted() {
    document.title = `${this.app_name} ${process.env.NODE_ENV === 'production' ? '' : process.env.NODE_ENV}`
    this.verify()
  },
};
</script>

<style>
@font-face {
  font-family: "Koho";
  src: local("Koho"),
    url(./assets/fonts/KoHo/KoHo-Regular.ttf) format("truetype");
}

* {
  box-sizing: border-box;
  font-size: 15px;
}

body {
  height: 100vh;
}

body {
  font-family: "Koho", sans-serif;
  background-color: #e9ecef !important;

}

.logo {
  text-align: center;
}

#main-header {
  background-color: white;
}

.input-labeled {
  background-color: transparent !important;
  border-color: transparent !important;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  margin-top: 60px;
}

/* Globals */
.form-group {
  margin: 2px 2px 2px 2px;
}

.navbar.navbar-light {
  border-bottom: 1px solid lightgray;
}

.is-number {
  text-align: right !important;
}

/* .table-grid tbody tr td input:not(.discount-input),
.table-grid tbody tr td svg, */
.input-grid {
  border-radius: 0px !important;
  border-width: 0px !important;
  margin: 0 auto !important;
  background: inherit;
}

.input-grid:disabled {
  background-color: inherit;
  color: gray;
}

.form-group label {
  margin-bottom: 0px !important;
}

.p-3 {
  padding: 0rem !important;
}

#table-container {
  height: 300px;
  overflow: auto;
  margin-top: 6px;
  max-width: 100%;
}

.sticky-table thead tr:first-child>th {
  position: sticky !important;
  top: 0;
  z-index: 999;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}

.input-group-text {
  background-color: inherit !important;
  /* border-left: none !important; */
  padding-left: 6px;
  padding-right: 6px;

}

/****Modal */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .5s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 45rem;
  margin: 50px auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-header {
  padding: 4px !important;
}

.modal-body {
  margin: 0px 0;
  padding: 2px !important;
}

.modal-default-button {
  float: right;
}

.card-body {
  padding: .50rem !important;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

/****Modal */

@media only screen and (max-width: 600px) {
  .modal-container {
    width: 100%;
  }

  body {
    max-width: 100%;
  }
}

.user-text {
  padding: 10px 10px 0px 0px !important;
  color: white !important;
}

.navbar {
  padding: 0px;
}

.table-sm td,
.table-sm th {
  padding-left: .5rem;
  padding-top: .1rem;
  padding-bottom: .1rem;
}

/* .input-group-prepend.bg-white .input-group-text {
   border: none;
 } */
input.flat,
select.flat,
textarea.flat {
  border-radius: 0px !important;
}

.input-group-prepend {
  margin-right: 0px !important;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter,
.component-fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue